import AppData from "../pacakge/public/const/app_data";

const { ccclass, menu, property, inspector } = cc._decorator;



@ccclass
@menu('UI/URichText')
export default class URichText extends cc.RichText {

 

    _containsTouchLocation (label, point) {
        let myRect = label.getBoundingBoxToWorld();
        myRect.x = AppData.designResolution.width / 2 + label.x
        return myRect.contains(point);
    }
}
